var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckCircle2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C19.9936 4.47982 15.5202 0.00642897 10 0Z",
    fill: "#B7B7B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7725 6.83362L10.0683 14.5745C9.93228 14.7549 9.72942 14.8732 9.50533 14.9027C9.28124 14.9321 9.05472 14.8703 8.87665 14.7311L4.80331 11.4745C4.44387 11.1868 4.38567 10.6622 4.67331 10.3028C4.96096 9.94334 5.48554 9.88514 5.84498 10.1728L9.24165 12.8903L14.4308 5.84778C14.601 5.59244 14.8977 5.45127 15.2032 5.48032C15.5086 5.50936 15.7734 5.70393 15.8924 5.98676C16.0114 6.2696 15.9653 6.59494 15.7725 6.83362Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle2);
export default __webpack_public_path__ + "static/media/check-circle-2.c02ee924cdba843c66f2fe9971e6289b.svg";
export { ForwardRef as ReactComponent };